import React from "react";
import styled from "styled-components";
import AvailablePeriods from "./AvailablePeriods";
import BackToPage from "../../elements/BackToPage";
import {tableBorderColour} from "../../../style/styleConsts";

const Container = styled.div`
    display: flex;
    align-items: center;
    padding-left: 30px;
    padding-right: 30px;
    border-bottom: 1px solid ${tableBorderColour};    
    background-color: #f5f2f0;
`;

const BackToPortfoliosContainer = styled.div`
    flex-grow: 1;
`;

export const Controls = ({periods, ourProgrammeContext, viewingOnDate}) => {
    function loggingPayloadFor(period) {
        const {portfolioId, portfolioName, companyWithinPortfolioId, companyWithinPortfolioName, periodBasis: previousPeriodBasis, startDate: previousStartDate} = ourProgrammeContext.context();
        const {periodBasis, startDate} = period;

        return {
            type: "REWARD_PERIOD_SELECTED",
            companyWithinPortfolioId,
            companyWithinPortfolioName,
            portfolioId,
            portfolioName,
            periodBasis,
            startDate,
            previousPeriodBasis,
            previousStartDate
        };
    }

    return <Container>
        <BackToPortfoliosContainer>
            <BackToPage destinationPage="PORTFOLIOS" path="/our-programme"/>
        </BackToPortfoliosContainer>
        <AvailablePeriods periods={periods}
                          isSelectedPeriod={ourProgrammeContext.isSelectedPeriod.bind(ourProgrammeContext)}
                          periodPath={ourProgrammeContext.periodPath.bind(ourProgrammeContext)}
                          loggingPayloadFor={loggingPayloadFor}
                          viewingOnDate={viewingOnDate}/>
    </Container>;
};
